import { uploadImage } from "../utils/uploadImage";
import { GET_RESTAURANTS, REMOVE_USER } from "./types";

const defaultSettings = {
	pin: "0000",
	isCashEnabled: true,
	schedule: {
		wednesday: {
			closing: "23:00",
			opening: "13:00",
		},
		monday: {
			opening: "13:00",
			closing: "23:00",
		},
		friday: {
			closing: "23:00",
			opening: "13:00",
		},
		tuesday: {
			opening: "13:00",
			closing: "23:00",
		},
		sunday: {
			closing: "23:00",
			opening: "13:00",
		},
		thursday: {
			closing: "23:00",
			opening: "13:00",
		},
		saturday: {
			closing: "23:00",
			opening: "12:30",
		},
	},
};

export const addManager = (data) => async (dispatch, getState) => {
	//Usuarios/managers/usuarios/{id}/ {db: ""}
	try {
		const {
			databasesRef: { managersDB },
		} = await getState().auth;

		const { uid, path, mail } = data;
		const userDocument = managersDB.doc(uid).get();
		const userExists = userDocument.exists;
		let userData = {};

		if (userExists) {
			userData = userDocument.data();
		}

		await managersDB.doc(uid).set({ ...userData, db: path, mail }, { merge: true });
		alert(`Se asigno ${path} a ${mail}`);
		dispatch({ type: REMOVE_USER });
	} catch (error) {
		alert(error);
		console.error(error);
	}
};

export const addRestaurant = (data, isEdit) => async (dispatch, getState) => {
	const {
		databasesRef: { storesDB, consoleDB },
	} = await getState().auth;
	try {
		const { path, restaurantImg, restaurantBannerImg, tags = "", ...restData } = data;

		const storesDocument = await storesDB.get();
		const currentStores = storesDocument.data().stores;
		const pathAlreadyExists = currentStores.find((store) => store.path === path);

		if (pathAlreadyExists && !isEdit) {
			throw new Error("Ya existe este restaurante, pruebe editarlo");
		}
		let ref, url, bannerUrl, bannerRef;

		if (restaurantImg.length > 0) {
			const params = await uploadImage(restaurantImg[0], "stores");
			ref = params.ref;
			url = params.url;
		}

		if (restaurantBannerImg.length > 0) {
			const params = await uploadImage(restaurantBannerImg[0], "stores");
			bannerRef = params.ref;
			bannerUrl = params.url;
		}

		let updatedStores = [];
		if (isEdit) {
			updatedStores = currentStores.filter((s) => s.path !== path);
		} else {
			updatedStores = currentStores;
		}

		const formattedTags = tags.split(",").map((tag) => tag.toLowerCase().trim());

		updatedStores = [
			...updatedStores,
			{
				...restData,
				imgUrl: url ? url : restData.imgUrl ? restData.imgUrl : "",
				reference: ref ? ref : restData.reference ? restData.reference : restData.ref ? restData.ref : "",
				bannerImgUrl: bannerUrl ? bannerUrl : restData.bannerImgUrl ? restData.bannerImgUrl : "",
				bannerRef: bannerRef ? bannerRef : restData.bannerRef ? restData.bannerRef : "",
				tags: formattedTags,
				path,
			},
		];

		await storesDB.update({ stores: updatedStores });

		if (!isEdit) await consoleDB.doc(data.path).set(defaultSettings, { merge: true });
		dispatch({ type: GET_RESTAURANTS, payload: updatedStores });
		alert("Se ha guardado con éxito");
	} catch (error) {
		alert(error);
	}
};

export const getRestaurants = () => async (dispatch, getState) => {
	const {
		databasesRef: { storesDB },
	} = await getState().auth;

	const storesDocument = await storesDB.get();
	const stores = storesDocument.data().stores;

	dispatch({ type: GET_RESTAURANTS, payload: stores });
};

export const deleteRestaurant = (restaurant) => async (dispatch, getState) => {
	const {
		databasesRef: { storesDB },
	} = await getState().auth;

	const storesDocument = await storesDB.get();
	const stores = storesDocument.data().stores;

	const newRestaurantList = stores.filter((store) => store.path !== restaurant);
	const confirmation = prompt(`Esta eliminado ${restaurant}, introduzca ${restaurant} para confirmar`, "");
	if (confirmation === restaurant) {
		await storesDB.update({ stores: newRestaurantList });
		dispatch({ type: GET_RESTAURANTS, payload: newRestaurantList });
	}
};
